import React from "react";

export default function VoucherHeader({
  voucherNo,
  setVoucherNo,
  invoiceDate,
  setInvoiceDate,
  voucherTypeLabel = "Outward Supply",
}) {
  return (
    <div className="bg-[#3f4247] text-white text-xs px-3 py-2 border-x border-gray-600 grid grid-cols-5 gap-3">
      <div>
        <div className="opacity-80">Voucher Type</div>
        <div className="font-semibold">{voucherTypeLabel}</div>
      </div>
      <div>
        <div className="opacity-80">Voucher No:</div>
        {typeof setVoucherNo === "function" ? (
          <input
            type="text"
            value={voucherNo}
            onChange={(e) => setVoucherNo(e.target.value)}
            placeholder="Enter voucher number"
            className="bg-black/30 px-2 py-1 rounded w-full text-white placeholder:text-white/50"
          />
        ) : (
          <div className="bg-black/30 px-2 py-1 rounded">{voucherNo || "NEW"}</div>
        )}
      </div>
      <div>
        <div className="opacity-80">Date</div>
        <input
          type="date"
          value={invoiceDate}
          onChange={(e) => setInvoiceDate(e.target.value)}
          className="bg-black/30 px-2 py-1 rounded w-full"
        />
      </div>
    </div>
  );
}
